export default __webpack_public_path__ + "static/media/tumorChannel0.894e0f1c.png";